


export const RequiredFields = {
    vehicle_details: {
        vehicle_reg_no: "",
        customer_id_type: "",
        owner_id: "",
        make_model: "",
        opc_vehicle_id: "",
        is_opc_car: ""
    },
    vehicle_documents: {
        log_card: [],
        sale_agreement: []
    },
    vehicle_documents_new: {
        sale_agreement: [],
        vehicle_overseas_log_card: [],
        data_card: [],
        cargo_clearance_permits: [],
        bill_of_lading: [],
        letter_of_newness: []
    },
    applicant_details: {
        title: "",
        name: "",
        nric: "",
        dob: "",
        gender: "",
        race: "",
        mobile_no: "",
        email: "",
        residence_type: "",
        home_address: "",
        postal_code: "",
        home_address_same_as_mailing: "",
        marital_status: ""
    },
    applicant_employement_details: {
        employment_type: "",
        occupation: "",
        type_of_industry: "",
        service_duration_years: "",
        service_duration_months: "",
        monthly_income: "",
        finance_type: "",
        employer_name: "",
        employer_address: "",
        employer_postal_code: "",
        other_income: "",
    },
    applicant_declaration: {
        declaration_date: "",
        received_discount_benefits: "",
        benefit_vendor_name: "",
        benefit_value: "",
        credit_hire_purchase: "",
        credit_facility_name: "",
        credit_value: "",
        sing_investment_related: "",
        sing_relationship_type: "",
        releated_with_vendor: "",
        vendor_relationship_type: "",
        credit_facility_with_sing_investment: "",
        sing_investment_credit_value: "",
        legal_actions: "",
        account_closed_by_singapore: "",
        closed_accounts_count: "",
        past_account_ssl: "",
        giro_account_no: "",
        past_account_tokyo_century: "",
        tokyo_century_account_no: "",
        primary_driver: "",
        driver_relationship: "",
        driver_name: "",
        driver_nric: "",
        form_data: [],
    },
    guarantor_details: {
        personal_details: {
            title: "",
            name: "",
            nric: "",
            dob: "",
            gender: "",
            race: "",
            mobile_no: "",
            email: "",
            residence_type: "",
            home_address: "",
            postal_code: "",
            home_address_same_as_mailing: "",
            marital_status: ""
        },
        employemnt_details: {
            employment_type: "",
            occupation: "",
            type_of_industry: "",
            service_duration_years: "",
            service_duration_months: "",
            monthly_income: "",
            finance_type: "",
            employer_name: "",
            employer_address: "",
            employer_postal_code: "",
        },
        documents: {
            nric: [],
            nao: [],
            cpf: [],
            driving_license: [],
            additional_documents: [],
            bank_statement: []
        }

    },
    guarantor_data_individual: {
        guarantor_type: "",
        guarantor_citizenship_type: ""
    },
    guarantor_data_company: {
        guarantor_type: "",
    },

    applicant_documents: {
        nric: [],
        nao: [],
        cpf: [],
        driving_license: [],
    },
    applicant_documents_wp: {
        nao: [],
        driving_license: [],
        work_permit: [],
        pay_slip: [],
        appoinment_letter: []
    },
    applicant_documents_fp: {
        passport: [],
        driving_license: [],
        bank_statement: [],
        pay_slip: [],
        employment_letter: []
    },
    company_applicant_documents: {
        company_acra: [],
        balance_sheet: [],
        bank_statement: [],
        p_l_document: [],
    }
    , declarationDetails: {
        declaration_date: "",
        received_discount_benefits: "",
        credit_hire_purchase: "",
        sing_investment_related: "",
        sing_relationship_type: "",
        releated_with_vendor: "",
        vendor_relationship_type: "",
        credit_facility_with_sing_investment: "",
        sing_investment_credit_value: "",
        legal_actions: "",
        account_closed_by_singapore: "",
        closed_accounts_count: "",
        past_account_ssl: "",
        giro_account_no: "",
        past_account_tokyo_century: "",
        tokyo_century_account_no: "",
        primary_driver: "",
        driver_relationship: "",
        driver_name: "",
        driver_nric: "",
        legal_action_content: "",
        form_data: [],
    }
}